<template>
  <div class="collection_opus">
    <template v-if="opus_collection_list.length">
      <opus_item v-for="(item, index) in opus_collection_list" :opus_obj="item" :key="index"></opus_item>
    </template>
    <div class="no_List" v-else></div>
    <div class="page_box">
      <my_page :layerpageinfo="layerpageinfo" @pageChange="changePage"></my_page>
    </div>
  </div>
</template>
<script>
import opus_item from "@/components/list_item/opus_item.vue";
import my_page from "@/components/myPage/myPage.vue";

export default {
  components: {
    opus_item,
    my_page
  },
  data() {
    return {
      opus_collection_list: [], //收藏过的作品列表
      layerpageinfo: {
        pageSize: 9,
        pageNo: 0,
        total: 0
      }
    };
  },
  created() {
    this.getFrontCollections();
  },
  methods: {
    // 页数切换
    changePage(pageNo) {
      this.layerpageinfo.pageNo = pageNo;
      this.getFrontCollections();
    },
    // 查询收藏的列表
    getFrontCollections() {
      let obj = {
        type: "CollectionTypeCollect",
        entity_type: "EntityTypeOpus"
      };
      this.api.getFrontCollections(obj).then(res => {
        console.log(res);
        if (res.error.err_code !== 0) return;
        let list = res.obj.list;
        this.layerpageinfo.total = res.obj.totalSize;

        // 根据收藏记录中的作品code查询作品信息
        list.forEach(item => {
          this.getOpuses(item.code);
        });
      });
    },
    // 根据code查询作品
    getOpuses(code) {
      this.opus_collection_list = [];
      this.api.getOpuses({ code: code }).then(res => {
        console.log(res);
        if (res.error.err_code !== 0) return;
        if (!res.obj.list.length) return;
        this.opus_collection_list.push(res.obj.list[0]);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.collection_opus {
  width: 862px;
  display: flex;
  flex-wrap: wrap;
  .opus_item {
    margin-right: 20px;
  }
  .opus_item:nth-child(3n) {
    margin-right: 0;
  }
  .no_List {
    background: url("~@/assets/img/common/no_list.png") no-repeat 100%;
    display: inline-block;
    width: 220px;
    height: 220px;
    // margin-left: 400px;
    margin: 0 auto;
    padding-top: 200px;
  }
}
</style>